import React from 'react'
import '../../Styles/Tile1.css';
//import {useState, useEffect} from 'react';
import TreLogo384 from '../../Assets/TreLogo384.png'
import { Link } from 'react-router-dom';
function Tile1(props) {
 
  return (
    <Link className='Tile1-container' to={`/article/${props.articleUID}`}>
        <img className="Tile1-image" alt="article feature image" src={props.featureImageURL ? props.featureImageURL : TreLogo384}/>
        <div className="Tile1-text-box">
            <p className='Title1-title'>{props.title}</p>
            <ul className='Title1-author-box'>
                <li className='Title1-author'>{props.author}</li>
                <li className='Title1-date'>{props.date.toDate().toLocaleDateString()}</li>
            </ul>
            
        </div> 
    </Link>
  )
}

Tile1.defaultProps = {
    title: "",
    author:"",
    link:"/",
    date:"",
    uid:"",
    articleUID:"",
    featureImageURL:"",
}

export default Tile1